import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as idcFunctions from '../../../../idc-functions'
import * as estimate from '../estimate'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: estimate.RESOURCE.payload.dimension.partialId,
      partialId: estimate.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Usually a subcategory of the Library category',
    isOptional: true,
    name: 'Library IDC Function',
    partialId: PartialId.Standard.create('func_idc'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        idcFunctions.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
